import { render, staticRenderFns } from "./index5.vue?vue&type=template&id=01e0fd02&scoped=true&"
import script from "./index5.vue?vue&type=script&lang=js&"
export * from "./index5.vue?vue&type=script&lang=js&"
import style0 from "./index5.vue?vue&type=style&index=0&id=01e0fd02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e0fd02",
  null
  
)

export default component.exports